import { FormEvent } from "react"
import { Button } from "../Button/Button"
import { Form } from "../Form/Form"
import { TextField } from "../TextField/TextField"
import { useAuth } from "@/stores/Auth"
import { useMutation } from "@tanstack/react-query"

export function Login() {
    const auth = useAuth()

    const {mutate, isPending} = useMutation({
        mutationFn: ({username, password, siteId}: {username: string, password: string, siteId: string}) =>  auth.login(username, password, siteId)
    })

    const login = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        const {username, password, siteId} = Object.fromEntries(new FormData(e.currentTarget)) as any
        mutate({username, password, siteId})
    }

    return (
        <Form onSubmit={login}>
            <TextField label="Username" name="username" type="email" isRequired />
            <TextField label="Password" name="password" type="password" isRequired />
            <TextField label="Site" name="siteId" />
            <Button isLoading={isPending} isDisabled={isPending} type="submit" className="flex">SIGN IN</Button>
        </Form>
    )
}